export enum EFieldTone {
  NEUTRAL = "NEUTRAL",
  POSITIVE = "POSITIVE",
  WARNING = "WARNING",
  CRITICAL = "CRITICAL"
}
